import IntlAddressBase from './Base'
import { censorAddress } from 'common/utils'

class UnknownAddress extends IntlAddressBase {

  constructor(props) {
    super(props)
  }

  toString() {
    return this.addr1
  }

  censored() {
    return censorAddress(this.addr1)
  }
}

export default UnknownAddress
